
import React, { useState } from "react";
import { Box, Menu, MenuItem, Typography, Dialog, DialogTitle, DialogContent, DialogActions, alpha, Avatar } from "@mui/material";
import ButtonComponent from "src/components/shared/Button";
import theme from "src/config/theme";
import { CardContainer, CardHeader, InnerContainer, ProfileContainer, Title, Year_Gender, Title2, Dot, Line, InnerContainer2, Title3, SymptomsContainer, SymptomsText, CheapContainer, MenuContainer, AvatarIcon, PatientCardContainer } from "./Style";
import { ReactComponent as More } from '../../../../assets/images/more.svg';
import { ReactComponent as Profile } from '../../../../assets/images/profile-circle.svg';
import { ReactComponent as ArrowRight } from '../../../../assets/images/arrow-right 2.svg';
import { ReactComponent as SliderVertical } from '../../../../assets/images/slider-vertical.svg';
import { ReactComponent as Edit2 } from '../../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../../assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../assets/images/add-square.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/images/close-circle.svg';
import { ReactComponent as Danger } from '../../../../assets/images/danger.svg';
import { ReactComponent as Call } from '../../../../assets/images/call.svg'

import { useNavigate } from 'react-router-dom';
import useResponsive from "src/components/hooks/useResponsive";


const ClinicCard = ({ data, handleOpen, handleOpenEdit }) => {
    const { isMobile, isDesktop, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '24px';
    const Height = isMobile || isTablet ? '18px' : '24px';

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleMenuOpen = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(item);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };


    const actions = [
        { label: "Edit", icon: <Edit2 width={Width} height={Height} />, onClick: (selectedRow) => handleOpenEdit(selectedRow.clinicId) },
        { label: "Clinic Profile", icon: <Profile width={Width} height={Height} />, onClick: (selectedRow) => handleOpen(selectedRow.clinicId) },

        // { label: "Cancel", icon: <Close />, onClick: () => handleOpen() }
    ];
    return (
        <Box sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '20px',
        }}>
            {data.map((item, index) => {
                return (
                    <PatientCardContainer key={index}>
                        <CardHeader sx={{ [theme.breakpoints.down('md')]: { padding: '20px', } }}>
                            <ProfileContainer sx={{ background: theme.palette.primary.light4 }}>
                                {item.avatarInitial}
                            </ProfileContainer>
                            <InnerContainer>
                                <Title>{item.name}</Title>
                                <Year_Gender sx={{ flexWrap: 'wrap' }}>
                                    <Title2 sx={{ fontWeight: 'bold' }}>Address</Title2>
                                    <Dot />
                                    <Title2 sx={{ flexWrap: 'nowrap' }}>{item.address}</Title2>
                                </Year_Gender>

                                <Box sx={{ display: 'flex', alignItems: 'center', width: '200px', gap: '10px' }}>

                                </Box>
                            </InnerContainer>
                        </CardHeader>
                        <Line sx={{ marginTop: '20px' }} />
                        <InnerContainer2 sx={{ justifyContent: 'flex-end', [theme.breakpoints.down('md')]: { padding: '0 20px', justifyContent: 'flex-end' } }}>
                            <MenuContainer
                                onClick={(event) => handleMenuOpen(event, item)}
                                isActive={selectedRow === item}
                            >
                                <More />
                            </MenuContainer>
                        </InnerContainer2>

                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            sx={{
                                "& .MuiPaper-root": {
                                    width: "176px",
                                    borderRadius: "12px",
                                    padding: "4px 18px",
                                    backgroundColor: "red",
                                    border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                                    backgroundColor: theme.palette.gery.white,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '14px',
                                }
                            }}
                        >
                            {actions.map((action, index) => (
                                <MenuItem key={index} onClick={() => {
                                    action.onClick(selectedRow);
                                    handleMenuClose();
                                }}>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        {action.icon} <Typography>{action.label}</Typography>
                                    </Box>
                                </MenuItem>
                            ))}
                        </Menu>
                    </PatientCardContainer>
                );
            })}
        </Box >
    );
};

export default ClinicCard;

